import React from 'react';
import { Typography } from '@mui/material';
import StyledSwitch from '../../../../../../StyledSwitch/StyledSwitch';
import { ItemBox } from './EventSwitches.styles';

const EventSwitches = ({ isRecurring, handleRecurringChange, isFullDays, handleFullDaysChange }) => (
  <>
    <ItemBox>
      <Typography variant="bodyRegular">Recurring</Typography>
      <StyledSwitch
        checked={isRecurring}
        onChange={handleRecurringChange}
        disabled={isFullDays}
        ariaLabel="Toggle recurring event"
      />
    </ItemBox>
    <ItemBox>
      <Typography variant="bodyRegular">Full Days</Typography>
      <StyledSwitch
        checked={isFullDays}
        onChange={handleFullDaysChange}
        disabled={isRecurring}
        ariaLabel="Toggle full days event"
      />
    </ItemBox>
  </>
);

export default EventSwitches;
